import React from 'react';
import { Box, Typography, Button, Stepper, Step, StepLabel } from '@mui/material';
import { ReviewSubmitData } from '../../types/forms';

interface WizardStepProps {
  currentStep: number;
  totalSteps: number;
  title: string;
  description: string;
  onNext: (data: ReviewSubmitData) => void;
  onBack: () => void;
  children: React.ReactNode;
  showButtons?: boolean;
}

const WizardStep: React.FC<WizardStepProps> = ({
  currentStep,
  totalSteps,
  title,
  description,
  onNext,
  onBack,
  children,
  showButtons = true
}) => {
  const steps = Array.from({ length: totalSteps }, (_, i) => `Step ${i + 1}`);

  const handleNext = () => {
    onNext({ currentStep: currentStep + 1 });
  };

  return (
    <Box>
      <Stepper activeStep={currentStep} sx={{ mb: 4 }}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      <Typography variant="h3" gutterBottom sx={{ fontWeight: 400 }}>
        {title}
      </Typography>
      <Typography variant="h6" color="text.secondary" paragraph sx={{ fontWeight: 400 }}>
        {description}
      </Typography>

      <Box sx={{ mt: 4 }}>
        {children}
      </Box>

      {showButtons && (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 4 }}>
          <Button
            variant="outlined"
            onClick={onBack}
            disabled={currentStep === 0}
          >
            Back
          </Button>
          <Button
            variant="contained"
            onClick={handleNext}
          >
            {currentStep === totalSteps - 1 ? 'Submit' : 'Next'}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default WizardStep; 